routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('authenticate', {
      url: '/authenticate?token&uid',
      template: '<p>Authenticating...<p><button data-ng-init="authenticate.login()" class="btn btn-default">Exec</button>',
      controller: 'AuthenticateController',
      controllerAs: 'authenticate'
    });
}


// WEBPACK FOOTER //
// ./src/client/app/authenticate/authenticate.route.js